import type { SVGProps } from 'react';
const directionalChevronupTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M19.6923 17.0056C19.9722 17.3109 20.4467 17.3316 20.752 17.0517C21.0573 16.7718 21.078 16.2973 20.7981 15.992L12.5481 6.99201C12.2508 6.66773 11.7396 6.66773 11.4423 6.99201L3.19234 15.992C2.91244 16.2973 2.93307 16.7718 3.23841 17.0517C3.54375 17.3316 4.01818 17.3109 4.29807 17.0056L11.9952 8.60955L19.6923 17.0056Z"
      fill={props.color ?? '#000'}
      fillRule="evenodd"
    />
  </svg>
);
export default directionalChevronupTemplateOutline;
